module.exports = __webpack_public_path__ + "static/media/postgreSQL.5ec94eed.png";